// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__15GzV","loaderOuter":"PageOverlayLoader_loaderOuter__34tHb"};